import { useLoad } from "../lib/api.jsx";
import { Wait, Tbl, money, day } from "../lib/ui.jsx";

const cols = [
  ["User", (s) => s.Name || s.user_id],
  ["Package", (s) => s.p_name],
  ["Ends", (s) => day(s.endDate)],
  ["Amount", (s) => money(s.paid_amount, s.paid_currency)],
];

export default function Dashboard() {
  const [d] = useLoad("stats");
  return (
    <>
      <h1>Dashboard</h1>
      <Wait d={d}>
        {d && !d.error && (
          <>
            <div className="stats">
              <div className="stat"><b>{d.users.total}</b><span>Users</span></div>
              <div className="stat"><b>{d.users.active}</b><span>Active accounts</span></div>
              <div className="stat"><b>{d.users.new30}</b><span>New in 30 days</span></div>
              <div className="stat"><b>{d.unverified}</b><span>Unverified</span></div>
              <div className="stat"><b>{d.activeSubs}</b><span>Active subscriptions</span></div>
              {d.revenue.map((r) => (
                <div className="stat" key={r.cur}><b>{Number(r.total).toLocaleString()}</b><span>Revenue ({r.cur})</span></div>
              ))}
            </div>
            <h2>Expiring within 7 days</h2>
            <Tbl cols={cols} rows={d.expiring} empty="No subscriptions expire this week." />
            <h2>Latest subscriptions</h2>
            <Tbl cols={cols} rows={d.recent} />
          </>
        )}
      </Wait>
    </>
  );
}
